export enum FreeSaleStatus {
	Closed = 'closed',
	NotEnoughSold = 'notEnoughSold',
	Open = 'open'
}